import { Box, Button, DataTable, Heading, Image, TextInput, Text, Anchor } from "grommet";
import React from "react";
import { BadgeViewModel, CreateBlanks, GetBadge, UpdateBadge, UpdateBadgeRequest } from "./BadgeStore";
import StyledModal from "../components/StyledModel";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../account/AccountStore";
import BadgeDetails from "./BadgeDetails";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { set } from "lodash";

const BadgeProfile = () => {
    const [badge, setBadge] = React.useState({} as BadgeViewModel | UpdateBadgeRequest);
    const { id } = useParams<{ id: string }>();

    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (id) {
            GetBadge(id).then((response) => {
                setBadge(response.result);
                setLoading(false);
            });
        }
    }, [id]);

    const [showCreateBlanksModal, setShowCreateBlanksModal] = React.useState(false);

    const startCreateBlanks = () => {
        setShowCreateBlanksModal(true);
    };

    const [blanksCount, setBlanksCount] = React.useState(0);

    const createBlanks = () => {
        let id = (badge as BadgeViewModel).id;

        CreateBlanks(id, blanksCount).then(() => {
            setShowCreateBlanksModal(false);
        });
    };

    const navigate = useNavigate();

    const update = () => {
        if (id) {
            UpdateBadge(badge as UpdateBadgeRequest).then(() => {
                GetBadge(id).then((response) => {
                    setBadge(response.result);
                });
            });
        }
    };

    return (
        <SkeletonWrapper loading={loading}>
            <Box direction="row" gap="small">
                <Image src={badge.logoURI} width="100%" style={{ maxWidth: "200px" }} fit="contain" />
                <Box gap="xsmall">
                    <Heading level={3}>{badge.name}</Heading>
                    <Text>{badge.description}</Text>
                    <Text>{(badge as BadgeViewModel).blanks?.length || 0} available to redeem</Text>
                </Box>
            </Box>

            <Box direction="row" gap="small">
                <Button primary label="Create Blanks" onClick={startCreateBlanks}></Button>
                <Button primary label="Award Badge" onClick={() => navigate(`/admin/badges/${(badge as BadgeViewModel).id}/award`)}></Button>
                <Button primary label="Get Redemption QR Codes" onClick={() => navigate(`/admin/badges/${(badge as BadgeViewModel).id}/print`)}></Button>
            </Box>
            
            <Box pad={"small"}>
                <BadgeDetails badge={badge as BadgeViewModel} isBusy={loading} onChange={(change) => setBadge({ ...badge, ...change })}></BadgeDetails>
            </Box>

            <Box direction="row" gap="small">
                <Button primary label="Update" onClick={update}></Button>
            </Box>
            <StyledModal isOpen={showCreateBlanksModal} setIsOpen={setShowCreateBlanksModal}>
                <Box>
                    <Image src={badge.logoURI} width="100%" style={{ maxWidth: "200px" }} fit="contain" />
                    <TextInput type="number" value={blanksCount} onChange={(e) => setBlanksCount(e.target.valueAsNumber)}></TextInput>
                    <Box direction="row">
                        <Button primary label="Create Blanks" onClick={createBlanks}></Button>
                    </Box>
                </Box>
            </StyledModal>
        </SkeletonWrapper>
    );
};

export default BadgeProfile;
